// import { useEffect } from "react";
// import roomsData from "../data/roomsData";
// import { loadRooms } from "../services/roomService";
// import { Link } from "react-router-dom";

// export default function AdminDashboard() {
//   useEffect(() => {
//     loadRooms(roomsData);
//   }, []);

//   return (
//     <div className="p-6">
//       <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>

//       <Link to="/manage-rooms">
//         <button className="p-3 bg-green-600 text-white rounded">
//           Manage Rooms
//         </button>
//       </Link>
//     </div>
//   );

// //   <RoomCard
// //   room={room}
// //   onEdit={() => handleEdit(room)}
// //   onDelete={() => handleDelete(room.id)}
// // />

// const handleEdit = (room) => {
//   navigate(`/edit-room/${room.id}`, { state: room });
// };

// const handleDelete = (id) => {
//   if (window.confirm("Are you sure?")) {
//     deleteRoom(id);          // localStorage or API
//     loadRoomsFromAPI();      // refresh UI
//   }
// };



// }
 

/***NEW DASHBOARD 9/1/26******* */

// AdminDashboard.jsx
// Works with existing React Router & ADMIN role
// import React, { useEffect, useState } from "react";
// import { Container, Row, Col, Card, Table, Button, Badge } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { Bar, Pie } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   ArcElement,
//   Tooltip,
//   Legend,
// } from "chart.js";

// ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Tooltip, Legend);

// export default function AdminDashboard() {
//   const navigate = useNavigate();


//   const [monthlyBookingData, setMonthlyBookingData] = useState({
//     labels: [],
//     datasets: [{ label: "Bookings", data: [] }],
//   });

//   const [occupancyData, setOccupancyData] = useState({
//     labels: [],
//     datasets: [{ data: [] }],
//   });

//   const [recentBookings, setRecentBookings] = useState([]);
//   const [totalRooms, setTotalRooms] = useState(0);

//   const [stats, setStats] = useState({
//   totalRooms: 0,
//   availableRooms: 0,
//   occupiedRooms: 0,
//   todaysBookings: 0,
//   monthlyBookings: 0,
// });



//   const loadStats = async () => {
//   try {
//     const statsRes = await axios.get("http://localhost:8080/api/admin/stats");
//     setStats(statsRes.data);

//     // OCCUPANCY
//     const occRes = await axios.get("http://localhost:8080/api/admin/stats/occupancy");
//     setOccupancyData({
//       labels: Object.keys(occRes.data),
//       datasets: [{ data: Object.values(occRes.data) }],
//     });

//     // MONTHLY BOOKINGS
//     const monthRes = await axios.get("http://localhost:8080/api/admin/stats/monthly-bookings");
//     setMonthlyBookingData({
//       labels: Object.keys(monthRes.data),
//       datasets: [{ label: "Bookings", data: Object.values(monthRes.data) }],
//     });


//     const recentRes = await axios.get("http://localhost:8080/api/admin/bookings/recent");
//     setRecentBookings(recentRes.data);

//   } catch (err) {
//     console.error("Failed to load stats", err);
//   }
// };

// useEffect(() => {
//   loadStats(); // first load

//   const interval = setInterval(() => {
//     loadStats(); // refresh every 10 seconds
//   }, 10000);

//   return () => clearInterval(interval);
// }, []);

// const cancelBooking = async (id) => {
//   try {
//     await axios.delete(`http://localhost:8080/api/admin/bookings/${id}`);
//     loadStats();           // refresh numbers
//   } catch (err) {
//     console.error("Cancel failed", err);
//   }
// };
 

//   <Button
//   size="sm"
//   variant="danger"
//   onClick={() => cancelBooking(booking.id)}
// >
//   Cancel
// </Button>




//   return (
//     <Container fluid className="bg-light min-vh-100">
//       <Row>
//         {/* Sidebar */}
//         <Col md={2} className="bg-success text-white p-4 min-vh-100">
//           <h4 className="fw-bold mb-4">NIVARA ADMIN</h4>
//           <div className="d-grid gap-3">
//             <Button variant="outline-light" onClick={() => navigate("/admin/dashboard")}>Dashboard</Button>
//             <Button variant="outline-light" onClick={() => navigate("/admin/manage-rooms")}>Rooms</Button>
//             <Button variant="outline-light" onClick={() => navigate("/admin/bookings")}>Bookings</Button>
//             <Button variant="outline-light"  onClick={() => navigate("/admin/contact-messages")}>Customers</Button>
//             <Button
//               variant="outline-warning"
//               onClick={() => {
//                 localStorage.clear();
//                 navigate("/login");
//               }}
//             >
//               Logout
//             </Button>
//           </div>
//         </Col>

//         {/* Main Content */}
//         <Col md={10} className="p-4">
//           <h2 className="fw-bold mb-4">Admin Dashboard</h2>

      


//             {/****Backend Data stats*** */}
//           <Row className="mb-4">
//   <Col md={3}><StatCard title="Total Rooms" value={stats.totalRooms} /></Col>
//   <Col md={3}><StatCard title="Occupied Rooms" value={stats.occupiedRooms} /></Col>
//   <Col md={3}><StatCard title="Available Rooms" value={stats.availableRooms} /></Col>
//   <Col md={3}><StatCard title="Today Bookings" value={stats.todaysBookings} /></Col>
// </Row>


//           {/* Charts */}
//           <Row className="mb-4">
//             <Col md={8}>
//               <Card className="shadow-sm">
//                 <Card.Body>
//                   <Card.Title>Monthly Bookings</Card.Title>
//                   <Bar data={monthlyBookingData} />
//                 </Card.Body>
//               </Card>
//             </Col>
//             <Col md={4}>
//               <Card className="shadow-sm">
//                 <Card.Body>
//                   <Card.Title>Room Occupancy</Card.Title>
//                   <Pie data={occupancyData} />
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           {/* Recent Bookings */}
//           <Card className="shadow-sm">
//             <Card.Body>
//               <Card.Title>Recent Bookings</Card.Title>
//               <Table hover responsive>
//                 <thead>
//                   <tr>
//                     <th>Customer</th>
//                     <th>Room</th>
//                     <th>Dates</th>
//                     <th>Status</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {recentBookings.map((b) => (
//                     //<BookingRow key={b.id} booking={b} />
//                     <BookingRow
//   key={b.id}
//   booking={b}
//   onCancel={cancelBooking}
// />



//                   ))}
//                 </tbody>
//               </Table>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// }

// function StatCard({ title, value }) {
//   return (
//     <Card className="shadow-sm">
//       <Card.Body>
//         <Card.Subtitle className="text-muted">{title}</Card.Subtitle>
//         <h3 className="fw-bold mt-2">{value}</h3>
//       </Card.Body>
//     </Card>
//   );
// }


// function BookingRow({ booking, onCancel }) {
//   return (
//     <tr>
//       <td>{booking.customerName}</td>
//       <td>{booking.roomName}</td>
//       <td>{booking.startDate} - {booking.endDate}</td>

//       <td>
//         <Badge bg={
//           booking.status === "PENDING"
//             ? "warning"
//             : booking.status === "CONFIRMED"
//             ? "success"
//             : "danger"
//         }>
//           {booking.status}
//         </Badge>
//       </td>

//       <td>
//         <Button
//           size="sm"
//           variant="danger"
//           onClick={() => onCancel(booking.id)}
//         >
//           Cancel
//         </Button>
//       </td>
//     </tr>
//   );
// }


//8/7/2026 

import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Table, Button, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Tooltip, Legend);

export default function AdminDashboard() {
  const navigate = useNavigate();

  const [monthlyBookingData, setMonthlyBookingData] = useState({
    labels: [],
    datasets: [{ label: "Bookings", data: [] }],
  });

  const [occupancyData, setOccupancyData] = useState({
    labels: [],
    datasets: [{ data: [] }],
  });

  const [recentBookings, setRecentBookings] = useState([]);

  const [stats, setStats] = useState({
    totalRooms: 0,
    availableRooms: 0,
    occupiedRooms: 0,
    todaysBookings: 0,
    monthlyBookings: 0,
  });

  const loadStats = async () => {
    try {
      const statsRes = await axios.get("http://localhost:8080/api/admin/stats");
      setStats(statsRes.data);

      const occRes = await axios.get("http://localhost:8080/api/admin/stats/occupancy");
      setOccupancyData({
        labels: Object.keys(occRes.data),
        datasets: [{ data: Object.values(occRes.data) }],
      });

      const monthRes = await axios.get("http://localhost:8080/api/admin/stats/monthly-bookings");
      setMonthlyBookingData({
        labels: Object.keys(monthRes.data),
        datasets: [{ label: "Bookings", data: Object.values(monthRes.data) }],
      });

      const recentRes = await axios.get("http://localhost:8080/api/admin/bookings/recent");
      setRecentBookings(recentRes.data);
    } catch (err) {
      console.error("Failed to load stats", err);
    }
  };

  useEffect(() => {
    loadStats();
    const interval = setInterval(() => {
      loadStats();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  const cancelBooking = async (id) => {
    try {
      await axios.delete(`http://localhost:8080/api/admin/bookings/${id}`);
      loadStats();
    } catch (err) {
      console.error("Cancel failed", err);
    }
  };

  return (
    <Container fluid className="bg-light min-vh-100">
      <Row>
        {/* Sidebar */}
        <Col md={2} className="bg-success text-white p-4 min-vh-100">
          <h4 className="fw-bold mb-4">NIVARA ADMIN</h4>
          <div className="d-grid gap-3">
            <Button variant="outline-light" onClick={() => navigate("/admin/dashboard")}>Dashboard</Button>
            <Button variant="outline-light" onClick={() => navigate("/admin/manage-rooms")}>Rooms</Button>
            <Button variant="outline-light" onClick={() => navigate("/admin/bookings")}>Bookings</Button>
            <Button variant="outline-light" onClick={() => navigate("/admin/contact-messages")}>Customers</Button>
            <Button
              variant="outline-warning"
              onClick={() => {
                localStorage.clear();
                navigate("/login");
              }}
            >
              Logout
            </Button>
          </div>
        </Col>

        {/* Main Content */}
        <Col md={10} className="p-4">
          <h2 className="fw-bold mb-4">Admin Dashboard</h2>

          <Row className="mb-4">
            <Col md={3}><StatCard title="Total Rooms" value={stats.totalRooms} /></Col>
            <Col md={3}><StatCard title="Occupied Rooms" value={stats.occupiedRooms} /></Col>
            <Col md={3}><StatCard title="Available Rooms" value={stats.availableRooms} /></Col>
            <Col md={3}><StatCard title="Today Bookings" value={stats.todaysBookings} /></Col>
          </Row>

          <Row className="mb-4">
            <Col md={8}>
              <Card className="shadow-sm">
                <Card.Body>
                  <Card.Title>Monthly Bookings</Card.Title>
                  <Bar data={monthlyBookingData} />
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="shadow-sm">
                <Card.Body>
                  <Card.Title>Room Occupancy</Card.Title>
                  <Pie data={occupancyData} />
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Card className="shadow-sm">
            <Card.Body>
              <Card.Title>Recent Bookings</Card.Title>
              <Table hover responsive>
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Room</th>
                    <th>Dates</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {recentBookings.map((b) => (
                    <BookingRow key={b.id} booking={b} onCancel={cancelBooking} />
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

function StatCard({ title, value }) {
  return (
    <Card className="shadow-sm">
      <Card.Body>
        <Card.Subtitle className="text-muted">{title}</Card.Subtitle>
        <h3 className="fw-bold mt-2">{value}</h3>
      </Card.Body>
    </Card>
  );
}

function BookingRow({ booking, onCancel }) {
  return (
    <tr>
      <td>{booking.customerName}</td>
      <td>{booking.roomName}</td>
      <td>{booking.startDate} - {booking.endDate}</td>
      <td>
        <Badge bg={
          booking.status === "PENDING"
            ? "warning"
            : booking.status === "CONFIRMED"
            ? "success"
            : "danger"
        }>
          {booking.status}
        </Badge>
      </td>
      <td>
        <Button
          size="sm"
          variant="danger"
          onClick={() => onCancel(booking.id)}
        >
          Cancel
        </Button>
      </td>
    </tr>
  );
}
